<div class="d-flex flex-column">
  <form #reqRoute="ngForm">
    <div class="row col-md-12">
      <div class="col-md-3">
        <label for="tipoVehiculo" class="form-label">Tipo de vehículo<strong class="text-danger">*</strong></label>
        <select class="form-select" aria-label="Default select example" [(ngModel)]="vehiculo.claseId"
            name="tipoVehiculo" id="tipoVehiculo" #tipoVehiculoId="ngModel" required>
            <option selected disabled>Seleccionar</option>
            <option *ngFor="let claseVehiculo of $parametricList.typeKindVehicle" [value]="claseVehiculo.idParametroDetalle">
              {{claseVehiculo.vcNombre}}</option>
        </select>

        <strong class="invalid-feedback d-block"
            *ngIf="tipoVehiculoId.invalid && (tipoVehiculoId.dirty || tipoVehiculoId.touched || submitted)">
            <span *ngIf="tipoVehiculoId.errors?.['required']">
                Campo obligatorio
            </span>
        </strong>
      </div>

      <div class="col-md-3">
        <label for="placa" class="form-label">Placa<strong class="text-danger">*</strong></label>
        <input type="text" class="form-control" id="placa" name="placa" [(ngModel)]="vehiculo.vcPlaca"
              #vcPlaca="ngModel" maxlength="50" required>

        <strong class="invalid-feedback d-block"
                *ngIf="vcPlaca.invalid && (vcPlaca.dirty || vcPlaca.touched || submitted)">
          <span *ngIf="vcPlaca.errors?.['required']">
            Campo obligatorio
          </span>
          <span *ngIf="vcPlaca.errors?.['maxlength']">
            Máximo 50 caracteres
          </span>
        </strong>
      </div>

      <div class="col-md-3">
          <label for="contratista" class="form-label">Contratista <strong class="text-danger">*</strong></label>
          <input type="text" class="form-control" id="contratista" name="contratista" [(ngModel)]="vehiculo.vcContratista"
                #vcContratista="ngModel" maxlength="50" required>

          <strong class="invalid-feedback d-block"
                  *ngIf="vcContratista.invalid && (vcContratista.dirty || vcContratista.touched || submitted)">
            <span *ngIf="vcContratista.errors?.['required']">
              Campo obligatorio
            </span>
            <span *ngIf="vcContratista.errors?.['maxlength']">
              Máximo 50 caracteres
            </span>
          </strong>
      </div>

      <div class="col-md-3">
        <label for="intIdentificacion" class="form-label">Número de identificación<strong class="text-danger">*</strong></label>
        <input type="text" class="form-control" id="intIdentificacion"  name="intIdentificacion" [(ngModel)]="vehiculo.vcNumeroDocumento"
               #intIdentificacion="ngModel" maxlength="20" required (keypress)="validateFormat($event)">

        <strong class="invalid-feedback d-block" *ngIf="intIdentificacion.invalid && (intIdentificacion.dirty || intIdentificacion.touched || submitted)">
          <span *ngIf="intIdentificacion.errors?.['required']">
            Campo obligatorio
          </span>
          <span *ngIf="intIdentificacion.errors?.['maxlength']">
            Máximo 20 caracteres
          </span>
        </strong>
      </div>
    </div>

    <br>

    <div class="row col-md-12">
      <div class="col-md-3">
        <label for="primerNom" class="form-label">Primer nombre<strong class="text-danger">*</strong></label>
        <input type="text" class="form-control" id="primerNom" name="primerNom" [(ngModel)]="vehiculo.vcPrimerNombre"
              #vcPrimerNombre="ngModel" maxlength="50" required>

        <strong class="invalid-feedback d-block"
                *ngIf="vcPrimerNombre.invalid && (vcPrimerNombre.dirty || vcPrimerNombre.touched || submitted)">
          <span *ngIf="vcPrimerNombre.errors?.['required']">
            Campo obligatorio
          </span>
          <span *ngIf="vcPrimerNombre.errors?.['maxlength']">
            Máximo 50 caracteres
          </span>
        </strong>
      </div>

      <div class="col-md-3">
        <label for="segundoNom" class="form-label">Segundo nombre</label>
        <input type="text" class="form-control" id="segundoNom" name="segundoNom" [(ngModel)]="vehiculo.vcSegundoNombre"
               maxlength="50">
      </div>

      <div class="col-md-3">
        <label for="primerApe" class="form-label">Primer apellido<strong class="text-danger">*</strong></label>
        <input type="text" class="form-control" id="primerApe" name="primerApe" [(ngModel)]="vehiculo.vcPrimerApellido"
              #vcPrimerApellido="ngModel" maxlength="50" required>

        <strong class="invalid-feedback d-block"
                *ngIf="vcPrimerApellido.invalid && (vcPrimerApellido.dirty || vcPrimerApellido.touched || submitted)">
          <span *ngIf="vcPrimerApellido.errors?.['required']">
            Campo obligatorio
          </span>
          <span *ngIf="vcPrimerApellido.errors?.['maxlength']">
            Máximo 50 caracteres
          </span>
        </strong>
      </div>

      <div class="col-md-3">
        <label for="segundoApe" class="form-label">Segundo apellido</label>
        <input type="text" class="form-control" id="segundoApe" name="segundoApe" [(ngModel)]="vehiculo.vcSegundoApellido"
               maxlength="50">
      </div>
    </div>

    <br>

    <div class="row col-md-12">
      <div class="col-md-3">
        <label for="vcTelefono" class="form-label">Teléfono celular de contacto<strong class="text-danger">*</strong></label>
        <input type="text" class="form-control" id="vcTelefono"  name="vcTelefono" [(ngModel)]="vehiculo.vcCelular"
                #vcTelefono="ngModel" maxlength="10" required (keypress)="validateFormat($event)">

        <strong class="invalid-feedback d-block" *ngIf="vcTelefono.invalid && (vcTelefono.dirty || vcTelefono.touched || submitted)">
          <span *ngIf="vcTelefono.errors?.['required']">
            Campo obligatorio
          </span>
          <span *ngIf="vcTelefono.errors?.['maxlength']">
            Máximo 10 caracteres
          </span>
        </strong>
      </div>

      <div class="col-md-3">
          <label for="vcCorreoElectronico" class="form-label">Correo electrónico<strong class="text-danger">*</strong></label>
          <input type="email" class="form-control" id="vcCorreoElectronico" [(ngModel)]="vehiculo.vcCorreoPersonal"
                #vcCorreo="ngModel" name="vcCorreoElectronico" pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$" required>

          <strong class="invalid-feedback d-block"
                  *ngIf="vcCorreo.invalid && (vcCorreo.dirty || vcCorreo.touched || submitted)">
            <span *ngIf="vcCorreo.errors?.['required']">
              Campo obligatorio
            </span>
            <span *ngIf="vcCorreo.errors?.['pattern']">
              Correo invalido
            </span>
          </strong>
      </div>
    </div>

    <br>
    <br>

    <div class="col-md-12 pe-4">
        <label for="id" class="form-label">Observación</label>
        <textarea class="form-control" rows="3" [(ngModel)]="vehiculo.vcObservacionSubContratado"
            name="txJustificacion" maxlength="800"></textarea>
    </div>
  </form>
</div>